import { Plus } from "@phosphor-icons/react";
import { Button } from "../../components/ui/button";
import { BomTree, nid } from "./wizardShared";

export default function StepBom({ pack, setPack }) {
  return (
    <div className="bg-[var(--c-surface)] border border-[var(--c-border)] rounded-lg shadow-sm p-5 max-w-2xl" data-testid="wizard-bom">
      <div className="flex items-center justify-between mb-4">
        <div className="text-[10px] font-mono tracking-widest uppercase text-[var(--c-muted)]">BOM Template · hierarchical material tree</div>
        <Button type="button" size="sm" data-testid="bom-add-root"
          onClick={() => setPack((p) => ({ ...p, bom_template: [...p.bom_template, { id: nid(), name: "New Group", children: [] }] }))}
          className="bg-[var(--c-border)] hover:bg-[var(--c-border)]/70 text-[var(--c-text)] h-7 rounded-sm text-xs"><Plus size={12} className="mr-1" /> Add Group</Button>
      </div>
      <BomTree nodes={pack.bom_template} onChange={(bom_template) => setPack((p) => ({ ...p, bom_template }))} />
      {pack.bom_template.length === 0 && <div className="text-xs text-[var(--c-muted)] py-4 text-center">Empty tree — add a top-level group.</div>}
    </div>
  );
}
